import { render } from "./Field.vue?vue&type=template&id=1cc96803"
import script from "./Field.vue?vue&type=script&lang=ts"
export * from "./Field.vue?vue&type=script&lang=ts"
script.render = render

export default script